"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoStepPutBodyToJSON = exports.PersonalInfoStepPutBodyFromJSONTyped = exports.PersonalInfoStepPutBodyFromJSON = void 0;
const _1 = require("./");
function PersonalInfoStepPutBodyFromJSON(json) {
    return PersonalInfoStepPutBodyFromJSONTyped(json, false);
}
exports.PersonalInfoStepPutBodyFromJSON = PersonalInfoStepPutBodyFromJSON;
function PersonalInfoStepPutBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'biographicInfo': _1.PreBiographicInfoStepPutBodyFromJSON(json['biographicInfo']),
        'contact': _1.PreContactStepFromJSON(json['contact']),
    };
}
exports.PersonalInfoStepPutBodyFromJSONTyped = PersonalInfoStepPutBodyFromJSONTyped;
function PersonalInfoStepPutBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'biographicInfo': _1.PreBiographicInfoStepPutBodyToJSON(value.biographicInfo),
        'contact': _1.PreContactStepToJSON(value.contact),
    };
}
exports.PersonalInfoStepPutBodyToJSON = PersonalInfoStepPutBodyToJSON;
//# sourceMappingURL=PersonalInfoStepPutBody.js.map